import { CorporateInt, MappedCorporateInt } from "@app/interfaces/micro/loyalty.interface";
import { Reservation } from "@app/models/micro/reservation.model";
import { Passenger } from "@models/micro";
export class LoyaltyMapper {

  constructor() {
  }

  static requestBenefits(passenger: Passenger, reservation: Reservation) {
    let requestBenefitsModel = new RequestBenefits(passenger, reservation);
    return requestBenefitsModel;
  }

  static requestAssosiateFFN(passenger: Passenger, reservation: Reservation) {
    let requestAssosiateFFNModel = new RequestAssosiateFFN(passenger, reservation);
    return requestAssosiateFFNModel;
  }

  static coreRequest(reservation: Reservation) {
    const { flightSummary, pnr } = reservation;
    const { currentSegment, legRegion } = flightSummary
    const { bookingClass, fareFamily } = currentSegment
    const passengers = reservation.passengers.filter(passenger => passenger.checkinSelected && passenger.passengerInfo.ffNumber)
      .filter(passeger => passeger.passengerInfo.ffProgram === 'AM' || passeger.passengerInfo.ffProgram === 'LA');

    const postData = passengers.map(passenger => {
      const { ancillaries, passengerInfo } = passenger;
      let { ffNumber, ffProgram, ffTierLevel } = passengerInfo

      const { lastName } = passenger;

      // Este campo se utiliza para enviar información adicional a la plataforma de beneficios.
      const details = '';
      let timeToDeparture = flightSummary.remainingTimeToDeparture;

      let isStandBy = reservation.isStandBy;

      if (timeToDeparture == null) {
        timeToDeparture = "0";
      }
      if (ffProgram === 'AM') {
        ffNumber = ffNumber.padStart(11, '0')
      }
      let lastname = lastName;
      return {
        accountNumber: ffNumber,
        bookingClass: bookingClass,
        fareFamily: fareFamily,
        region: legRegion,
        timeToDeparture: timeToDeparture,
        ffTierLevel,
        ffProgram,
        pnr,
        lastname,
        isStandBy,
        details,
        ancillaries,
      };
    });
    return postData.length > 0 ? postData : [];
  }

  static coreResponse(response: any) {
    const [warnings] = response

    return response

  }

 static corporateResponse(response: CorporateInt):MappedCorporateInt {
    const { id, benefitName, customizedValueOneC, corporateBenefits, seats, cobrandBenefits } = response
    return {
      id,
      benefitName,
      companyName:customizedValueOneC,
      corporateBenefits,
      seats,
      cobrandBenefits,
    }
  }
}

export class RequestBenefits {
  accountNumber: string;
  fareFamily: string;
  ffName: string;
  bookingClass: string;
  region: string;
  timeToDeparture: string;
  isStandBy: boolean;
  operatingCarrier: string;
  details2: string;
  beneficiaryTier: string;


  constructor(passenger: Passenger, reservation: Reservation) {

    const { ffNumber, ffProgram, dateOfBirth: birthday, } = passenger.passengerInfo
    const { firstName, lastName } = passenger.passengerInfo;
    const { flightSummary } = reservation;

    this.accountNumber = ffNumber;
    this.bookingClass = flightSummary.currentSegment.bookingClass;
    this.ffName = "";
    this.region = flightSummary.legRegion;
    this.timeToDeparture = flightSummary.remainingTimeToDeparture;
    this.isStandBy = reservation.isEmployee;
    this.operatingCarrier = reservation.flightSummary.operatingCarrier;
    this.details2 = "";
    this.beneficiaryTier = "";
  }
}

export class RequestAssosiateFFN {
  accountNumber: string;
  loyaltyProgram: string;
  pnr: string;
  passengerNameNumber: string;
  firstname: string;
  lastname: string;
  birthday: string;

  constructor(passenger: Passenger, reservation: Reservation) {

    let { ffNumber, ffProgram, dateOfBirth } = passenger.passengerInfo
    let { firstName, lastName } = passenger
    const { flightSummary } = reservation;
    if(ffProgram === 'AM') {
      ffNumber = ffNumber.padStart(11,'0')
    }

    this.accountNumber = ffNumber;
    this.loyaltyProgram = ffProgram;
    this.pnr = reservation.pnr;
    this.passengerNameNumber = passenger.nameRefNumber;
    this.firstname = firstName;
    this.lastname = lastName;
    this.birthday = dateOfBirth;
  }
}


